exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#qst_list[data-v-0184ee60] {\n  height: 200px;\n  overflow-y: scroll;\n}\n.qst[data-v-0184ee60] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.qst p[data-v-0184ee60] {\n  font-size: 16px;\n}\n.flex-1[data-v-0184ee60] {\n  flex: 1;\n}\n", ""]);

// exports
